import styled from "styled-components";

import { useNewGivingUI } from "Flocknote/apiHooks";

import { useOngoingCampaigns } from "NavBar/API/queryHooks";
import LinkListRow, {
  LinkListRowsWrapper,
} from "NavBar/components/LinkListRow";
import { menuTypographyProps } from "NavBar/components/NavLink";
import NavSectionDivider from "NavBar/components/NavSectionDivider";
import { navSectionKeys } from "NavBar/navBarStore";

import ColorSquare from "UI/FnrColorSquare";
import FnrScaleIt from "UI/FnrScaleIt";
import FnrTypography from "UI/FnrTypography";

import Amount from "./Amount";
import ListTitle from "./ListTitle";

/**
 * Classic giving has no campaign route of its own — it shows a campaign as a
 * filtered fund view, the same URL the classic Campaigns page links to.
 */
export const getCampaignUrl = (
  hideLegacyGivingUI,
  { ID, givingTransactionFundID }
) =>
  hideLegacyGivingUI
    ? `giving/campaigns/${ID}`
    : `giving?fund=${givingTransactionFundID}&campaignID=${ID}`;

const OngoingCampaigns = () => {
  const { ongoingCampaigns, showOngoingCampaigns } = useOngoingCampaigns();
  const { hideLegacyGivingUI } = useNewGivingUI();

  if (!showOngoingCampaigns) return null;

  return (
    <>
      <NavSectionDivider />
      <ListTitle title="Campaigns" icon="bullhorn fas" />
      <LinkListRowsWrapper>
        {ongoingCampaigns.map((campaign) => (
          <LinkListRow
            data-cy={`NavBar_Campaign${campaign.ID}`}
            key={campaign.ID}
            to={getCampaignUrl(hideLegacyGivingUI, campaign)}
            navSectionKey={navSectionKeys.giving}
            omitNumericIndicator
          >
            <ColorAndNameWrapper>
              <FnrScaleIt scale={0.8}>
                <ColorSquare
                  circle
                  selected
                  backgroundColor={campaign.fundColor}
                  size="sm"
                />
              </FnrScaleIt>
              <FnrTypography {...menuTypographyProps} noWrap={false}>
                {campaign.title}
              </FnrTypography>
            </ColorAndNameWrapper>
            {/* Campaign totals run from the campaign's own start date, so the
                fiscal/calendar year label the funds above use doesn't apply. */}
            <Amount
              showPeriodLabel={false}
              amount={Math.round(
                (campaign.unpledgedAmountGiven || 0) +
                  (campaign.pledgedAmountGiven || 0)
              )}
            />
          </LinkListRow>
        ))}
      </LinkListRowsWrapper>
    </>
  );
};

const ColorAndNameWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export default OngoingCampaigns;
